import { render, staticRenderFns } from "./CompensatoryLeavesListApproved.vue?vue&type=template&id=de64e748"
import script from "./CompensatoryLeavesListApproved.vue?vue&type=script&lang=js"
export * from "./CompensatoryLeavesListApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports